import Axios from "axios";
import { url } from "../Constants";
import { showLog } from "./log";

const headers = {
  Accept: "*",
  "Content-type": "application/json",
  "Access-Control-Allow-Origin": "*",
};

export const Request = Axios.create({
  headers: headers,
});

export default class baseRequest {
  constructor() {
    this.urls = {};
  }

  async post(api, params = {}) {
    showLog("Request Masuk post");
    const userServer = JSON.parse(localStorage.getItem("userServer"));
    let dataBranch = JSON.parse(localStorage.getItem("dataBranch"));
    params["from_origin"] = "*";
    if (userServer) {
      params["userServer"] = userServer;
      params["branch_id"] = dataBranch?.branchID;
    }
    // params["userServer"] = "uruz2"
    // params["branch_id"] = "OE_KOTU"
    showLog("===== START =====");
    showLog(`HITTED URL = ${url + api}`);
    showLog(`PARAMS     = ${params}`);
    const response = await Request.post(url + api, params);
    showLog(`RESPONSE   = ${response}`);
    showLog("===== END =====");
    return response.data;
  }
}
